import { Address } from './address.model';
import { OrganizationDetailData, OrganizationMembership } from './organization.model';

export interface User {
  id?: string;
  address?: Address;
  salutation?: SalutationType;
  firstname: string;
  lastname?: string;
  email?: string;
  language?: string;
  userType: UserType;
  mfa?: boolean;
  phone?: string;
  position?: string;
  organization?: OrganizationDetailData;
  organizationMemberships?: OrganizationMembership[];
  mfaSettings?: {
    mfaMandatory: boolean;
    version: number;
  };
  version?: number;
  skipMfa?: boolean;
}

export enum SalutationType {
  m = 'm',
  w = 'w',
  d = 'd',
}

export enum UserType {
  TECHNICAL = 'TECHNICAL',
  NATURAL = 'NATURAL',
}
